// extracted by mini-css-extract-plugin
module.exports = {"postcodeInput":"SingleFieldLookupAddressForm_postcodeInput__gLOjq"};